// Store scroll position before navigation
document.querySelectorAll('.product__sibling-link, .head-link a').forEach((link) => {
    link.addEventListener('click', (e) => {
        const scrollY = window.scrollY;
        localStorage.setItem('scrollToSibling', 'true');
        localStorage.setItem('scrollY', scrollY);
    });
});

// On load, restore scroll position if flag is set
document.addEventListener('DOMContentLoaded', function () {
    if (localStorage.getItem('scrollToSibling') === 'true') {
        localStorage.removeItem('scrollToSibling');
        const savedScrollY = localStorage.getItem('scrollY');
        if (savedScrollY) {
            localStorage.removeItem('scrollY');
            window.scrollTo({ top: parseInt(savedScrollY), behavior: 'auto' });
        }
    }
});

